import { Action } from 'redux';

import { UpdateUserSettings } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { IUserSettings } from '../models/IUserSettings';

export interface UpdateUserSettingsAction extends Action {
  domain: string;
  username: string;
  userSettings: IUserSettings;
}

export function updateUserSettingsAction(username: string, domain: string, userSettings: IUserSettings): UpdateUserSettingsAction {
  return {
    type: UpdateUserSettings,
    domain: domain,
    username: username,
    userSettings: userSettings
  };
}

export const isUpdateUserSettingsAction = isActionFactory<UpdateUserSettingsAction>(UpdateUserSettings);
